import PropTypes from 'prop-types';
import React from 'react';

import {CNPJ_TYPES} from '../../../constants/typesMessages';
import Cnpj from '../../Cnpj';
import Form from '../../Form';

const FlowCnpj = (props) => {
  switch (props.valueFlow) {
    case CNPJ_TYPES.CNPJ:
      return <Cnpj {...props} />;

    case CNPJ_TYPES.LN:
      return <div id="legal-name" />;

    case CNPJ_TYPES.FN:
      return <div id="fantasy-name" />;

    case CNPJ_TYPES.CNAE:
      return <div id="cnae" />;

    default:
      return <Form {...props} />;
  }
};

FlowCnpj.propTypes = {
  valueFlow: PropTypes.string
};

export default FlowCnpj;
